__turbopack_context__.v({
  "container": "TextSectionsBlock-module__xhvzIG__container",
  "content": "TextSectionsBlock-module__xhvzIG__content",
  "fadeInItems": "TextSectionsBlock-module__xhvzIG__fadeInItems",
  "menu": "TextSectionsBlock-module__xhvzIG__menu",
  "menuLink": "TextSectionsBlock-module__xhvzIG__menuLink",
  "menuSublink": "TextSectionsBlock-module__xhvzIG__menuSublink",
  "spacing--lg": "TextSectionsBlock-module__xhvzIG__spacing--lg",
  "spacing--md": "TextSectionsBlock-module__xhvzIG__spacing--md",
  "spacing--sm": "TextSectionsBlock-module__xhvzIG__spacing--sm",
  "spacing--xl": "TextSectionsBlock-module__xhvzIG__spacing--xl",
  "spacing--xs": "TextSectionsBlock-module__xhvzIG__spacing--xs",
  "spacing--xxl": "TextSectionsBlock-module__xhvzIG__spacing--xxl",
  "spacing--xxs": "TextSectionsBlock-module__xhvzIG__spacing--xxs",
  "spacing--xxxl": "TextSectionsBlock-module__xhvzIG__spacing--xxxl",
  "spacing--xxxs": "TextSectionsBlock-module__xhvzIG__spacing--xxxs",
});
